import "core-js/modules/web.dom-collections.iterator.js";
import { useState } from "react";
import styled from "styled-components";
import { GLYPHS, StyledIcon } from "../../Styled/Icon";
import Text from "../../Styled/Text";
import { OutsideClickHandler } from "../Generic/OutsideClickHandler";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A popup overflow menu for the panel
 */
export const PanelMenu = _ref => {
  let {
    options
  } = _ref;
  const [isOpen, setIsOpen] = useState(false);
  const hideMenu = () => setIsOpen(false);
  const handleClick = (onSelect, event) => {
    setIsOpen(false);
    onSelect(event);
  };
  return /*#__PURE__*/_jsx(OutsideClickHandler, {
    onOutsideClick: hideMenu,
    disabled: !isOpen,
    children: /*#__PURE__*/_jsxs(PanelMenuContainer, {
      children: [/*#__PURE__*/_jsx(PanelMenuButton, {
        isOpen: isOpen,
        onClick: () => setIsOpen(true),
        children: /*#__PURE__*/_jsx(StyledIcon, {
          glyph: GLYPHS.menuDotted
        })
      }), isOpen && /*#__PURE__*/_jsx("ul", {
        children: options.map(_ref2 => {
          let {
            text,
            onSelect,
            disabled
          } = _ref2;
          return /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(PanelMenuItem, {
              onClick: e => handleClick(onSelect, e),
              disabled: disabled,
              children: /*#__PURE__*/_jsx(Text, {
                noWrap: true,
                medium: true,
                textLight: true,
                children: text
              })
            })
          }, text);
        })
      })]
    })
  });
};
const PanelMenuContainer = styled.div.withConfig({
  displayName: "PanelMenu__PanelMenuContainer",
  componentId: "sc-15dcawh-0"
})(["position:relative;ul{position:absolute;right:2px;z-index:1;margin:2px 1px 0 0;padding:0;list-style:none;border-radius:3px;border:1px solid ", ";background-color:", ";}ul > li{border:0px;border-bottom:1px solid ", ";}ul > li:last-child{border-bottom:0;}"], p => p.theme.grey, p => p.theme.dark, p => p.theme.grey);
const PanelMenuItem = styled.button.withConfig({
  displayName: "PanelMenu__PanelMenuItem",
  componentId: "sc-15dcawh-1"
})(["width:100%;text-align:left;padding:8px 10px;border:0;border-radius:2px;background-color:", ";:disabled > ", "{color:", ";}:hover{cursor:pointer;background-color:", ";}"], p => p.theme.dark, Text, p => p.theme.textLightDimmed, p => p.theme.colorPrimary);
const PanelMenuButton = styled.button.withConfig({
  displayName: "PanelMenu__PanelMenuButton",
  componentId: "sc-15dcawh-2"
})(["outline:0 !important;padding:8px;margin:0 3px;background:none;border:0px;border-radius:2px;svg{fill:", ";width:16px;height:16px;}", ";:hover{cursor:pointer;}"], props => props.theme.greyLighter, p => p.isOpen && "background-color: ".concat(p.theme.dark));